import { MethodsEditor } from '@/features/tools/components/authenticate-caller/MethodsEditor'
import { PersonsEditor } from '@/features/tools/components/authenticate-caller/PersonsEditor'
import type {
  DraftState,
  MethodRow,
} from '@/features/tools/components/authenticate-caller/authenticationDraft'

export function AuthenticationSettingsEditor({
  draft,
  methodsOverridden,
  personsOverridden,
  interactionDisabled,
  showInheritance,
  onUpdateRow,
  onRemoveRow,
  onAddRow,
  onResetMethods,
  onTogglePerson,
  onResetPersons,
  onAddCustomPerson,
}: {
  draft: DraftState
  methodsOverridden: boolean
  personsOverridden: boolean
  interactionDisabled: boolean
  showInheritance: boolean
  onUpdateRow: (index: number, row: MethodRow) => void
  onRemoveRow: (index: number) => void
  onAddRow: () => void
  onResetMethods: () => void
  onTogglePerson: (person: string) => void
  onResetPersons: () => void
  onAddCustomPerson: (person: string) => void
}) {
  return (
    <>
      <MethodsEditor
        rows={draft.methods}
        methodsOverridden={methodsOverridden}
        interactionDisabled={interactionDisabled}
        onUpdateRow={onUpdateRow}
        onRemoveRow={onRemoveRow}
        onAddRow={onAddRow}
        onResetToOrg={onResetMethods}
        showInheritance={showInheritance}
      />
      <PersonsEditor
        allowedPersons={draft.allowedPersons}
        personsOverridden={personsOverridden}
        interactionDisabled={interactionDisabled}
        onTogglePerson={onTogglePerson}
        onResetToOrg={onResetPersons}
        onAddCustomPerson={onAddCustomPerson}
        showInheritance={showInheritance}
      />
    </>
  )
}
